import {API_HOST, API_ROOT, http} from "../../util/http";
import {handleTokenErrors} from "./errors";

export const SET_LOCATIONS = "locations/SET_LOCATIONS";
export const SET_PICKUP_LOCATIONS = "locations/SET_PICKUP_LOCATIONS";

export function setLocations(locations) {
    return {
        type: SET_LOCATIONS,
        payload: {
            locations: locations
        }
    }
}

export function setPickupLocations(pickupLocations) {
    return {
        type: SET_PICKUP_LOCATIONS,
        payload: {
            pickupLocations: pickupLocations
        }
    }
}

export function fetchLocations() {
    return (dispatch) => {
        return http.get(API_HOST + API_ROOT + 'all-locations', true)
            .then(response => {
                dispatch(setLocations(response.result));
            })
            .catch(error => {
                handleTokenErrors(error);
            });
    }
}

export function fetchPickupLocations() {
    return (dispatch) => {
        return http.get(API_HOST + API_ROOT + 'pickup-locations', true)
            .then(response => {
                dispatch(setPickupLocations(response.result));
            })
            .catch(error => {
                handleTokenErrors(error);
            });
    }
}

const initialState = {
    locations: null,
    pickupLocations: null,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOCATIONS: {
            return {
                ...state,
                locations: action.payload.locations
            }
        }
        
        case SET_PICKUP_LOCATIONS: {
            return {
                ...state,
                pickupLocations: action.payload.pickupLocations
            }
        }
        
        default:
            return state;
    }
}
